import { useMemo } from 'react';
import { Box, Button, Divider, IconButton, Paper, Typography } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { useLocation, useNavigate } from 'react-router';
import { useAppContext } from '../../contexts/AppContext';
import { buildOrderSummary, formatCurrency, shippingMethods } from './checkoutData';
import '../Customer/CustomerScreens.scss';

export default function EReceipt() {
  const navigate = useNavigate();
  const location = useLocation();
  const { cartItems } = useAppContext();
  const shipping = location.state?.shipping || shippingMethods[0];
  const summary = useMemo(
    () => location.state?.summary || buildOrderSummary(cartItems, shipping.amount),
    [location.state, cartItems, shipping.amount]
  );

  return (
    <Box className='customer-screen'>
      <Box className='customer-shell'>
        <Box className='customer-topbar'>
          <IconButton className='customer-iconButton' onClick={() => navigate(-1)}>
            <ArrowBackRoundedIcon />
          </IconButton>
          <Typography className='customer-topbarTitle'>E-Receipt</Typography>
          <Box sx={{ width: 46 }} />
        </Box>

        <Paper className='customer-card' sx={{ p: 2 }}>
          <Box className='checkout-barcode' />

          {cartItems.map((item) => (
            <Box key={item.id}>
              <Box className='checkout-productRow'>
                <Box
                  component='img'
                  src={item.image}
                  alt={item.name}
                  className='checkout-productThumb'
                />
                <Box>
                  <Typography sx={{ fontWeight: 700 }}>{item.name}</Typography>
                  <Typography className='customer-muted'>{item.size || 'Standard'}</Typography>
                  <Typography sx={{ fontWeight: 700 }}>
                    {formatCurrency(Number(item.price || 0) * Number(item.quantity || 1))}
                  </Typography>
                </Box>
              </Box>
              <Divider />
            </Box>
          ))}

          <Box className='customer-stack' sx={{ mt: 2 }}>
            <Box className='customer-summaryRow'>
              <Typography className='customer-muted'>Order Date</Typography>
              <Typography sx={{ fontWeight: 700 }}>{summary.orderDate}</Typography>
            </Box>
            <Box className='customer-summaryRow'>
              <Typography className='customer-muted'>Promo code</Typography>
              <Typography sx={{ fontWeight: 700 }}>{summary.promoCode}</Typography>
            </Box>
            <Box className='customer-summaryRow'>
              <Typography className='customer-muted'>Delivery Type</Typography>
              <Typography sx={{ fontWeight: 700 }}>{shipping.label}</Typography>
            </Box>
            <Divider />
            <Box className='customer-summaryRow'>
              <Typography className='customer-muted'>Amount</Typography>
              <Typography sx={{ fontWeight: 700 }}>{formatCurrency(summary.amount)}</Typography>
            </Box>
            <Box className='customer-summaryRow'>
              <Typography className='customer-muted'>Delivery Charge</Typography>
              <Typography sx={{ fontWeight: 700 }}>
                {formatCurrency(summary.shippingAmount)}
              </Typography>
            </Box>
            <Box className='customer-summaryRow'>
              <Typography className='customer-muted'>Tax</Typography>
              <Typography sx={{ fontWeight: 700 }}>{formatCurrency(summary.tax)}</Typography>
            </Box>
            <Divider />
            <Box className='customer-summaryRow'>
              <Typography sx={{ fontWeight: 800 }}>Total</Typography>
              <Typography sx={{ fontWeight: 800, fontSize: '1.05rem' }}>
                {formatCurrency(summary.total)}
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Paper className='checkout-stickyFooter'>
          <Button className='customer-actionButton customer-actionButton--primary' fullWidth>
            Download E-Receipt
          </Button>
        </Paper>
      </Box>
    </Box>
  );
}
